import { O_CREAT } from 'constants';

const mapToServerObject = settingSet => {
    const central_settings = {};

    settingSet.central_settings.forEach(cs => {
        central_settings[cs.name] = cs.value;
    });

    const outlets = settingSet.outlets.map(o => o.id);

    return Object.assign(_.pick(settingSet, ['name', 'id', 'description']), {
        central_settings,
        outlets,
    });
};

export default {
    namespaced: true,
    state: {
        settingSet: {
            id: null,
            name: null,
            default: false,
            description: null,
            outlets: [],
            central_settings: [],
        },
        assignedOutletList: [],
    },
    getters: {
        settingSet: state => state.settingSet,

        outletTaken: state => set_id => {
            return state.assignedOutletList
                .filter(o => o.central_setting_set_id != set_id)
                .map(o => o.outlet_id);
        },

        groupedSettings: state => {
            return _.groupBy(
                state.settingSet.central_settings,
                cs => cs.group.id,
            );
        },
    },
    mutations: {
        setSettingSet(state, set) {
            state.settingSet = set;
        },

        setSettingValue(state, { index, value }) {
            state.settingSet.central_settings[index].value = value;
        },

        setSettingSetAttibute(state, { attr, value }) {
            state.settingSet[attr] = value;
        },

        setOutlets(state, outlets) {
            state.settingSet.outlets = outlets;
        },

        setAssignedOutletList(state, assignedOutlets) {
            state.assignedOutletList = assignedOutlets;
        },
    },
    actions: {
        createSettingSet(context, set) {
            const route = Laroute.route(
                'franchise.setting.central_settings.set.create',
            );

            return axios.post(route, set);
        },

        getSettingSet(context, id) {
            const url = Laroute.route(
                'franchise.setting.central_settings.set.show',
                { id },
            );

            return axios.get(url);
        },

        setSettingSet({ commit }, set) {
            commit('setSettingSet', set);
        },

        setSettingValue({ commit, state }, { name, value }) {
            const index = state.settingSet.central_settings.findIndex(
                cs => cs.name == name,
            );

            commit('setSettingValue', { index, value });
        },

        updateSettingSet(context, set) {
            const url = Laroute.route(
                'franchise.setting.central_settings.set.update',
                { id: set.id },
            );

            return axios.put(url, mapToServerObject(set));
        },

        setOutlets({ commit }, outlets) {
            commit('setOutlets', outlets);
        },

        setSettingSetAttibute({ commit }, { attr, value }) {
            commit('setSettingSetAttibute', { attr, value });
        },

        async getAssignedOutletList({ commit }) {
            const url = Laroute.route(
                'franchise.setting.central_settings.set.assigned_outlets',
            );

            let { data } = await axios.get(url);
            commit('setAssignedOutletList', data);
        },

        async getMultiselectOptionValues(_, { id, params = {} }) {
            const url = Laroute.route(
                'franchise.setting.central_settings.set.multiselect_options',
                { id },
            );

            return axios.get(url, {
                params: {
                    query: params.query || '',
                    limit: params.limit || '', // for switch type, limit will be ignored in the backend
                    ...(params.outletIds && {
                        outlet_ids: params.outletIds,
                    }),
                },
            });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/central-settings.js